<script lang="ts" setup></script>
<template>
  <svg
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3333 4.70833H14.9024V1.83333C14.9024 1.57917 14.8014 1.33541 14.6217 1.15569C14.442 0.975967 14.1982 0.875 13.944 0.875H7.55579C7.30163 0.875 7.05787 0.975967 6.87815 1.15569C6.69843 1.33541 6.59746 1.57917 6.59746 1.83333V8.54167H1.16659C0.912419 8.54167 0.668664 8.64263 0.488941 8.82236C0.309219 9.00208 0.208252 9.24583 0.208252 9.5V17.1667C0.208252 17.4208 0.309219 17.6646 0.488941 17.8443C0.668664 18.024 0.912419 18.125 1.16659 18.125H20.3333C20.5874 18.125 20.8312 18.024 21.0109 17.8443C21.1906 17.6646 21.2916 17.4208 21.2916 17.1667V5.66667C21.2916 5.4125 21.1906 5.16875 21.0109 4.98902C20.8312 4.8093 20.5874 4.70833 20.3333 4.70833ZM6.59746 16.2083H2.12492V10.4583H6.59746V16.2083ZM12.9857 16.2083H8.51413V2.79167H12.9857V16.2083ZM19.3749 16.2083H14.9024V6.625H19.3749V16.2083Z"
      fill="#65676b"
    />
  </svg>
</template>
